import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineUnpin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    viewBox="0 0 15 15"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="m10.886 7.613 2.908-1.69a1.05 1.05 0 0 0 .22-1.617L10.645.935a1.05 1.05 0 0 0-1.617.22L7.284 4.023 2.57 5.072a.63.63 0 0 0-.305 1.05l6.458 6.468a.64.64 0 0 0 1.05-.315zM.65 14.3l4.894-4.894"
    />
  </svg>
);
export default SvgStreamlineUnpin;
